import { logOutUser } from "../store/admin/auth-slice";
import { logOutAgent } from "../store/agent/auth-slice";
import { createApiClient } from "./createApiClient";

export const API_URL: string = import.meta.env.VITE_API_URL;
export const AGENT_API_URL: string = import.meta.env.VITE_AGENT_API_URL;

const admin = createApiClient({
  baseURL: API_URL,
  onLogout: logOutUser,
});
export const axiosObj = admin.instance;
export const setupResponseInterceptors = admin.setupResponseInterceptors;
export const refreshAdminSession = admin.refreshSession;

const agent = createApiClient({
  baseURL: AGENT_API_URL,
  onLogout: logOutAgent,
});
export const agentAxiosObj = agent.instance;
export const setupAgentResponseInterceptors = agent.setupResponseInterceptors;
export const refreshAgentSession = agent.refreshSession;
